export const daysOptions = [
    { jourLabel: "Lundi", jourNombre: 1 },
    { jourLabel: "Mardi", jourNombre: 2 },
    { jourLabel: "Mercredi", jourNombre: 3 },
    { jourLabel: "Jeudi", jourNombre: 4 },
    { jourLabel: "Vendredi", jourNombre: 5 },
    { jourLabel: "Samedi", jourNombre: 6 },
    { jourLabel: "Dimanche", jourNombre: 7 }
]